import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
  OnInit,
  ChangeDetectorRef,
  NgZone,
  DoCheck
} from '@angular/core';
import { FieldConfig, FormUpdateMode, InterfaceDisplayType } from '../../api/contract-notice-dto';
import { FormGroup, FormBuilder } from '@angular/forms';
import { FormService } from './form.service';
import { FormGroupConfig, ErrorFieldGroup } from './form.objects';
import { TranslateService } from '@ngx-translate/core';
import { UUID } from 'angular2-uuid';
import { BaseComponent } from '../common/baseComponent/base.component';
import { ServiceLocator } from '../../ServiceLocator';
import { VisibilityEvent } from './formElement.component';


@Component({
  selector: 'formGroup',
  templateUrl: 'formGroup.template.html'
})
export class FormGroupComponent extends BaseComponent implements OnInit, OnDestroy, DoCheck {
  @Input() formGroupConfig: FormGroupConfig;
  @Input() formGroup: FormGroup;
  @Input() errors: ErrorFieldGroup;
  @Input() displayErrorCount = false;
  @Input() showHeader = true;
  @Input() lastChangesApplied: Date;
  @Input() updateOnChange: FormUpdateMode;
  @Output()
  updateForm: EventEmitter<boolean> = new EventEmitter(false);
  @Output()
  public visibleEvt = new EventEmitter<VisibilityEvent>();

  public InterfaceDisplayType = InterfaceDisplayType;

  public createForm = true;
  public formConfigFinished = false;
  timerPending: any;
  zone: NgZone;
  private visibilityMap = new Map<String, Boolean>();
  private visible = true;

  // control de carga
  @Output()
  loaded: EventEmitter<string> = new EventEmitter(undefined);
  // lista de componentes formGroup pendientes de carga
  private loadingSubcomponentIds = new Array<string>();

  constructor(
    private fb: FormBuilder,
    public translationService: TranslateService,
    private changeDetectorRef: ChangeDetectorRef,
    public formService: FormService
  ) {
    super();
    this.zone = ServiceLocator.injector.get(NgZone);
  }

  ngDoCheck() {
    if (this.updateOnChange !== FormUpdateMode.ONCHANGE) {
      // Al estar desactivada la deteccion de cambios (ChangeDetectionStrategy.OnPush en FormElement)
      //  ,forzamos su recarga cada pocos segundos y sin que se solapen actaulizaciones de las vistas
      if (!this.lastChangesApplied) {
        // Si no se ha aplicado ningun cambio, aplicar y detectar cambios
        this.lastChangesApplied = new Date();
      } else {
        let millsBetweenTwoDate = Math.abs((new Date().getTime() - this.lastChangesApplied.getTime()));
        if (millsBetweenTwoDate > 1000) {
          // Si no se ha aplicado ningun cambio en el último segundo, aplicar y detectar cambios
          this.lastChangesApplied = new Date();
        } else if (!this.timerPending) {
          // Si ha pasado menos de un segundo desde la ultima actualizacion, programar una actualizacion para un segundo despues
          // siempre que no haya una ya programada (con esto garantizamos que siempre se actaulizara el ultimo cambio que llegue)
          this.timerPending = setTimeout(() => {
            this.timerPending = null;
            this.lastChangesApplied = new Date();
            this.changeDetectorRef.detectChanges();
          }, 1000);
        }
      }
    }
  }

  /**
   * Metodo al que se invoca cada vez que un control envia señal de actualizacion
   * @param value
   */
  public sendUpdateView(value: any): void {
    this.updateForm.next(value);
  }

  ngOnInit(): void {
    if (!this.formGroupConfig) {
      throw new Error('Error onfiguracion del grupo de campos del formulario');
    }
    this.createForm = !this.formGroup;
    if (this.createForm) {
      this.formGroup = this.fb.group(
        {},
        {
          syncValidator: this.formGroupConfig.syncValidationFn,
          asyncValidator: this.formGroupConfig.asyncValidationFn
        }
      );
    }
    this.showHeader = this.formGroupConfig.group.showHeader;
    let formFields = new Array<FieldConfig>();
    this.formGroupConfig.group.fieldList.forEach((field: FieldConfig) => {
      // establecer referencia al grupo al que pertenece el campo
      field.fieldGroup = this.formGroupConfig.group;
      if (!this.formService.getFormControlKey(field)) {
        // si no tiene jsonField o id (titulos o etiquttas)
        // establecer id para navegabilidad
        field.id = field.type + '_' + UUID.UUID();
      }
      formFields.push(field);
    });
    if (formFields.length === 0) {
      this.formConfigFinished = true;
      // emitir el identificador del grupo asociado como cargado
      this.loaded.emit(this.formGroupConfig.group.id);
      console.log('Ocultar formulario no hay componentes !!!!!!');
      this.emmitVisibility(false);
    } else {
      let loadingSubcomponentIds = new Array<string>();
      let myIndex = 1;
      let autofocus = true;
      formFields.forEach((field: FieldConfig) => {
        field.editable = this.formGroupConfig.readonly ? false : field.editable;
        let formControlId = this.formService.getFormControlKey(field);
        field.id = formControlId;
        if (field.id) {
          if (loadingSubcomponentIds.indexOf(formControlId) > 0) {
            throw new Error(
              'Error existe más de un elemento en el grupo ' +
              this.formGroupConfig.group.id +
              ' con id:' +
              formControlId
            );
          } else {
            console.log('Elemento ', formControlId, ' registrado para espera');
            loadingSubcomponentIds.push(formControlId);
          }
        } else {
          console.log(
            'Atención el campo',
            field,
            ' no tiene los atributos jsonField ni id'
          );
        }
      });
      this.loadingSubcomponentIds = loadingSubcomponentIds;
      this.formConfigFinished = true;
    }
  }

  ngOnDestroy(): void {
    this.formGroupConfig = null;
    this.formGroup = null;
    this.errors = null;
    this.zone = null;
    super.ngOnDestroy();
  }

  private isFormField(type: string): boolean {
    return type !== 'TITLE' && type !== 'LABEL' && type !== 'BREAK-ROW';
  }

  getDescription(): string {
    return this.formService.getDescription(this.formGroupConfig.group, this.formGroupConfig);
  }

  public markElementAsLoaded(id: string): void {
    if (id) {
      console.log('Elemento ', id, ' Cargado');
      this.loadingSubcomponentIds = this.loadingSubcomponentIds.filter(
        (componentId: string) => componentId !== id
      );
      if (this.isFormLoaded()) {
        console.log(
          'Grupo ',
          this.formGroupConfig.group.id,
          ' informa cargado'
        );
        // emitir el identificador del grupo asociado como cargado
        this.loaded.emit(this.formGroupConfig.group.id);
      }
    }
  }

  private isFormLoaded(): boolean {
    return this.loadingSubcomponentIds?.length === 0;
  }

  public updateVisibility(evt: VisibilityEvent): void {
    this.visibilityMap.set(evt.id, evt.visible);
    if (this.isFormLoaded() && this.visibilityMap?.size > 0) {
      const visible = [... this.visibilityMap.values()].find(value => value) !== undefined;
      this.emmitVisibility(visible);
    }
  }

  private emmitVisibility(visible: boolean): void {
    if (visible !== this.visible) {
      // si cambia el estado emitimos el cambio
      this.visible = visible;
      this.visibleEvt.emit({ id: this.formGroupConfig.group.id, visible: visible });
      console.log('Emitiendo visibilidad grupo: ' + this.formGroupConfig.group.id + ', a ' + visible);
    }
  }

}
